import Button, { ButtonProps } from '../../button';
import { FeaturedIcon, FeaturedIconProps } from '../../featured-icon';
import { PopupModalTheme } from '..';
import { twMerge } from 'tailwind-merge';

export const ButtonPanel = ({
  featuredIcon,
  tertiaryButtonInfo,
  primaryButtonInfo,
  theme,
  ...props
}: {
  featuredIcon?: FeaturedIconProps;
  tertiaryButtonInfo?: ButtonProps;
  primaryButtonInfo?: ButtonProps;
  theme?: PopupModalTheme;
} & React.HtmlHTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={twMerge(`mt-6 flex ${featuredIcon ? 'justify-between' : 'justify-end'}`, props?.className)}>
      {featuredIcon && <FeaturedIcon {...featuredIcon} />}
      <div className="flex gap-8">
        {tertiaryButtonInfo?.text && (
          <Button
            theme={theme}
            text={tertiaryButtonInfo?.text}
            size="large"
            variant="tertiary"
            onClick={tertiaryButtonInfo.onClick}
            disabled={primaryButtonInfo?.disabled}
            {...tertiaryButtonInfo}
          />
        )}
        {primaryButtonInfo?.text && (
          <Button
            theme={theme}
            text={primaryButtonInfo?.text}
            size="large"
            variant="primary"
            onClick={primaryButtonInfo?.onClick}
            disabled={primaryButtonInfo?.disabled}
            {...primaryButtonInfo}
          />
        )}
      </div>
    </div>
  );
};

export default ButtonPanel;
